import React from 'react'
import Banner from'../assets/Benner.png'
const Benner = () => {
  return (
    
    <section id='benner'>
        <section style={{background:`url(${Banner})`}} className=' z-[1] h-[783px] w-full relative after:absolute after:top-0 after:left-0 after:contents[""] after:bg-[#000000a8] after:h-full after:w-full after:z-[-1]'>
<div className="">
<div className="pt-[247px] pl-[330px]">
<h1 className=' font-poppi font-semibold text-[64px] text-white'>We exist since 1975 on the <br /> oil and gas industry.</h1>
</div>
<div className="w-[156px] h-[41px] bg-[#F40404] items-center justify-center ml-[390px] border-2 border-[#F40404] hover:bg-transparent" >
<p className=' pt-[10px] justify-center text-center text-white font-poppi text-xs font-semibold'>LEARN MORE</p>
</div>
</div>
    </section>
    </section>
  )
}

export default Benner